import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const RequireAuth = ({ allowedPermissions, checkInstitutionResponsible = false }) => {
    const { auth } = useAuth();
    const location = useLocation();

    return (
        
        auth?.user?.permissions?.find(permission => allowedPermissions?.includes(permission)) || 
            (checkInstitutionResponsible && auth?.user?.institutionResponsible)
            ? <Outlet />
            : auth?.token
                ? <Navigate to="/unauthorized" state={{ from: location }} replace />
                : <Navigate to="/login" state={{ from: location }} replace />
    );
}

export default RequireAuth;